<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <p class="summary-text">{{data.detail}}</p>
</div>
<div mat-dialog-actions>
  <div class="filler"></div>
  <button mat-button [mat-dialog-close]="">{{data.accept}}</button>
</div>